export default __webpack_public_path__ + "static/media/red_3.ac776f2e.png";